import styled from "styled-components";

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FormSection = styled.div`
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 16px;
`;

export const FormSectionTitle = styled.h4`
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
  margin: 0 0 12px 0;
`;
export const SectionDescription = styled.p`
  font-size: 0.875rem;
  color: #64748b;
  margin: 0 0 16px 0;
`;
